import TokenIcon from "./TokenIcon.mjs";
import {
  getPerkIcon,
  getRedeemedPerkIcon
} from "../data/perkIcons.mjs";

export default function CurrentPerks({ perks }) {
  // TODO: Check if a unique ID is ever assigned to a currently redeemed prime perk.
  // TODO: Change `perk.name` to category whenever they add that to the API for icon
  const mappedPerks = perks.map((perk, index) =>
    <div className="col-md-6 col-xl-4" key={index}>
      <div className="perk-card bg-light rounded">
        <div className="d-flex gap-2 mb-3 align-items-center">
          <div className="text-tier">
            <TokenIcon name={getPerkIcon(perk.name)} width="40" height="40" />
          </div>
          <div className="">
            <p className="mb-1 fs-lg fw-medium lh-1">{perk.name}</p>
            <p className="mb-0 label-3 lh-1">{perk.description}</p>
          </div>
        </div>
        <div className="d-flex justify-content-between align-items-center label-4">
          <span>Acquired: {perk.beginMonth}/{perk.beginYear}</span>
          <span>Expires After: {perk.throughMonth}/{perk.throughYear}</span>
        </div>
      </div>
    </div>
  );

  return (
    <div className="current-perks mb-5-5">
      <h3 className="subhead-2 text-dark-subtle mb-3">Current Prime Perks & Balances</h3>

      <div className="row gy-3">
        {mappedPerks}
      </div>
    </div>
  );
}
